import React from 'react';

import BookprocessWidget from '../BookprocessWidgets';
import Label from '../form/Label';
import WidgetCheckbox from './WidgetCheckbox';
import WidgetGroup from './WidgetGroup';
import WidgetInput from './WidgetInput';
import WidgetNumberWithButtons from './WidgetNumberWithButtons';
import WidgetText from './WidgetText';
import WidgetVoucherDiscountCode from './WidgetVoucherDiscountCode';

import BookprocessWidgetProps from './interfaces/BookprocessWidgetPropsInterface';
import PropsCheckbox from './interfaces/PropsCheckboxInterface';
import PropsGroup from './interfaces/PropsGroupInterface';
import PropsNumber from './interfaces/PropsNumberInterface';
import PropsText from './interfaces/PropsTextInterface';
import PropsVoucherDiscountCode from './interfaces/PropsVoucherDiscountCodeInterface';
import WidgetStatic from './WidgetStatic';
import WidgetSelect from './WidgetSelect';
import PropsSelect from './interfaces/PropsSelectInterface';
import WidgetDetails from './WidgetDetails';

export default class WidgetGroupInput extends React.Component<BookprocessWidgetProps, {}> {
    render() {
        let image;
        if (this.props._links && this.props._links['recras:image']) {
            let className = this.props._links['recras:image'].href.includes('boekproces_afbeelding')
                ? 'labelBookprocessImage'
                : 'labelImage';
            image = React.createElement('img', {
                key: this.props.id + '_img',
                className: className,
                src: this.props._links['recras:image'].href,
            });
        }

        const priceEl = this.props.price
            ? React.createElement(WidgetStatic, this.props.price)
            : null;

        const creditEl = this.props.credit
            ? React.createElement(WidgetStatic, this.props.credit)
            : null;

        const extraInfoEl = this.props.extraInfo
            ? React.createElement(WidgetDetails, this.props.extraInfo)
            : null;

        switch (this.props.type) {
            case 'group':
                let groupele = React.createElement(WidgetGroup, this.props as PropsGroup);

                return React.createElement(
                    'div',
                    {
                        className: this.props.className + ' ' + this.props.type + 'Wrapper',
                    },
                    <Label htmlFor={groupele.props.id} text={this.props.label} />,
                    priceEl,
                    creditEl,
                    image,
                    extraInfoEl,
                    groupele
                );

            case 'text':
                if (this.props.recrastype === 'discount') {
                    let discountEle = React.createElement(
                        WidgetVoucherDiscountCode,
                        this.props as PropsVoucherDiscountCode
                    );
                    return React.createElement(
                        'div',
                        { className: this.props.type + 'Wrapper' },
                        <Label htmlFor={discountEle.props.id} text={this.props.label} />,
                        discountEle
                    );
                } else {
                    let textele = React.createElement(WidgetText, this.props as PropsText);
                    return React.createElement(
                        'div',
                        { className: this.props.type + 'Wrapper' },
                        <Label htmlFor={textele.props.id} text={this.props.label} />,
                        textele
                    );
                }

            case 'number':
                const numberElement = React.createElement(
                    WidgetNumberWithButtons,
                    this.props as PropsNumber
                );

                let numberClasses = [this.props.className, this.props.type + 'Wrapper'];

                if (this.props.disabled || this.props.max === 0) {
                    numberClasses.push('disabled');
                }

                const numberCapacity = this.shouldRenderCapacity()
                    ? React.createElement(
                          'span',
                          { className: 'timeslot-capacity' },
                          this.props.max
                      )
                    : null;

                return React.createElement(
                    'div',
                    { className: numberClasses.join(' ') },
                    <Label htmlFor={numberElement.props.id} text={this.props.label} />,
                    priceEl,
                    image,
                    extraInfoEl,
                    numberCapacity,
                    numberElement
                );

            case 'checkbox':
                let checkEle = React.createElement(WidgetCheckbox, this.props as PropsCheckbox);

                const text = this.shouldRenderCapacity()
                    ? `${this.props.label} <span class="checkbox-capacity">${this.props.max}</span>`
                    : this.props.label;

                let cbClasses = [this.props.className, this.props.type + 'Wrapper'];
                return React.createElement(
                    'div',
                    { className: cbClasses.join(' ') },
                    priceEl,
                    extraInfoEl,
                    checkEle,
                    <Label htmlFor={checkEle.props.id} text={text} />
                );

            case 'static':
                return BookprocessWidget.getWidget(this.props);

            case 'radio':
                let inputEl = React.createElement(WidgetInput, this.props);

                let labelTextEl = React.createElement('span', {}, this.props.label);
                let imageEl = null;
                if (
                    this.props.recrastype === 'payment_method' &&
                    this.props._links &&
                    this.props._links['recras:image']?.href
                ) {
                    imageEl = React.createElement('img', {
                        title: this.props.label,
                        alt: this.props.label,
                        src: this.props._links['recras:image'].href,
                        className: 'paymentIcon',
                    });
                }
                let labelEl = React.createElement(
                    'label',
                    {
                        htmlFor: inputEl.props.id,
                    },
                    imageEl,
                    labelTextEl
                );

                return React.createElement(
                    'div',
                    { className: this.props.type + 'Wrapper' },
                    priceEl,
                    extraInfoEl,
                    inputEl,
                    labelEl
                );

            case 'select':
                let selectEl = React.createElement(WidgetSelect, this.props as PropsSelect);

                let checkboxEl;
                let htmlFor = selectEl.props.id;
                if (this.props.recrastype === 'product_with_time_dropdown') {
                    checkboxEl = React.createElement(WidgetCheckbox, {
                        id: selectEl.props.id + '_checkbox',
                        name: selectEl.props.id + '_checkbox',
                        type: 'checkbox',
                        value: selectEl.props.auto_enable_checkbox ? 'on' : null,
                        disabled: selectEl.props.auto_enable_checkbox,
                        getStateValue: this.props.getStateValue,
                        handleChange: (name, value) => {
                            if (!selectEl.props.auto_enable_checkbox) {
                                if (!value) {
                                    selectEl.props.handleChange(selectEl.props.name, null);
                                }
                                this.props.handleChange(name, value);
                            }
                        },
                    } as PropsCheckbox);
                    htmlFor += '_checkbox';
                }

                return React.createElement(
                    'div',
                    { className: this.props.type + 'Wrapper' },
                    checkboxEl,
                    <Label htmlFor={htmlFor} text={this.props.label} />,
                    priceEl,
                    extraInfoEl,
                    selectEl
                );

            default:
                let inputele = React.createElement(WidgetInput, this.props);
                return React.createElement(
                    'div',
                    { className: this.props.type + 'Wrapper' },
                    <Label htmlFor={inputele.props.id} text={this.props.label} />,
                    inputele
                );
        }
    }

    shouldRenderCapacity() {
        return this.props.settings?.showCapacity && 'max' in this.props;
    }
}
